import { IconButtonProps, InputAdornmentProps } from "@mui/material";
import { MouseEvent, ReactElement } from "react";

import { SVG_MUI } from "@ryde/assets";

import { AdornmentButton } from "./button";

interface IAdornmentLensButtonProps {
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  position?: InputAdornmentProps["position"];
  size?: IconButtonProps["size"];
  buttonProps?: Omit<IconButtonProps, "onClick" | "size" | "onMouseDown">;
}

export const AdornmentLensButton = ({
  onClick,
  position = "start",
  size = "small",
  buttonProps,
}: IAdornmentLensButtonProps): ReactElement => {
  return (
    <AdornmentButton
      onClick={onClick}
      position={position}
      size={size}
      buttonProps={buttonProps}
    >
      <SVG_MUI.LensInTextboxSVG width={14} height={14} />
    </AdornmentButton>
  );
};
